import { StepContainer } from '../components/StepContainer'
import { SingleSelect } from '../components/SingleSelect'
import { useOnboardingStore } from '../store/onboardingStore'
import type { PrimaryGoal } from '../types/onboarding'
import { SingleSelectV2, PRIMARY_GOAL_V2_ICONS } from '../components/v2'
import { usesAppLook } from '../lib/variant'

const options: { value: PrimaryGoal; label: string; emoji: string }[] = [
  { value: 'manage_ckd', label: 'Manage my CKD diet', emoji: '🏥' },
  { value: 'slow_progression', label: 'Slow kidney disease progression', emoji: '🛡️' },
  { value: 'dialysis_support', label: 'Dialysis diet support', emoji: '💊' },
  { value: 'post_transplant', label: 'Post-transplant nutrition', emoji: '💚' },
  { value: 'kidney_stones', label: 'Prevent kidney stones', emoji: '🪨' },
  { value: 'caregiver', label: "I'm a caregiver", emoji: '🤝' },
  { value: 'general_health', label: 'General kidney health', emoji: '❤️' },
  { value: 'exploring', label: 'Just exploring', emoji: '👀' },
]

const v2Options = options.map(({ value, label }) => ({ value, label, icon: PRIMARY_GOAL_V2_ICONS[value] }))

export function PrimaryGoalStep() {
  const { data, goNext } = useOnboardingStore()

  return (
    <StepContainer
      title="What's your primary goal?"
      subtitle="This helps us personalize your experience"
      showContinue={false}
    >
      {usesAppLook() ? (
        <SingleSelectV2
          options={v2Options}
          value={data.primaryGoal}
          onChange={(value) => goNext({ primaryGoal: value })}
        />
      ) : (
        <SingleSelect
          options={options}
          value={data.primaryGoal}
          onChange={(value) => goNext({ primaryGoal: value })}
        />
      )}
    </StepContainer>
  )
}
